"use client"

import {
  agents,
  getAgentByTaskClass,
  type AgentInfo,
} from '@sourcepilot/generated/api-manifest'

export type { AgentInfo }

/**
 * The agent a user gets without choosing: the one the instance marks
 * `default` (RFLP — Tom, 2026-10-13; members never see the picker), else the
 * first one.
 */
export function pickDefaultAgent(list: readonly AgentInfo[]): AgentInfo | undefined {
  return list.find((a) => a.default) ?? list[0] ?? undefined
}

/**
 * Hook providing agent metadata from the generated API manifest.
 *
 * All data is statically generated at codegen time — no async fetch needed.
 */
export function useAgents() {
  const defaultAgent = pickDefaultAgent(agents)

  return {
    agents,
    defaultAgent,
    getAgentByTaskClass,
  }
}
